import script from "./DictDataEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./DictDataEdit.vue?vue&type=script&setup=true&lang=js"

import "./DictDataEdit.vue?vue&type=style&index=0&id=bb7e5e64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_06ebbe948ebbc1bd3ebd6c3aad4ab6ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb7e5e64"]])

export default __exports__